import api from "./api";

const classService = {
  // Get all classes with search/filter
  getAllClasses: async (params = {}) => {
    const response = await api.get("/api/classes", { params });
    return response.data.data || response.data;
  },

  // Get class by ID
  getClassById: async (id) => {
    const response = await api.get(`/api/classes/${id}`);
    return response.data.data || response.data;
  },

  // Create new class with file upload
  createClass: async (classData, imageFile = null) => {
    const formData = new FormData();
    formData.append("board_id", classData.board_id);
    formData.append("class_name", classData.class_name);
    if (classData.is_active !== undefined) {
      formData.append("is_active", classData.is_active);
    }

    if (imageFile) {
      formData.append("image", imageFile);
    }

    const response = await api.post("/api/classes", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data.data || response.data;
  },

  // Update class with file upload
  updateClass: async (id, classData, imageFile = null) => {
    const formData = new FormData();
    formData.append("board_id", classData.board_id);
    formData.append("class_name", classData.class_name);
    if (classData.is_active !== undefined) {
      formData.append("is_active", classData.is_active);
    }

    if (classData.image_url !== undefined) {
      formData.append("image_url", classData.image_url || "");
    }

    if (imageFile) {
      formData.append("image", imageFile);
    }

    const response = await api.put(`/api/classes/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data.data || response.data;
  },

  // Delete class
  deleteClass: async (id) => {
    const response = await api.delete(`/api/classes/${id}`);
    return response.data.data || response.data;
  },
};

export default classService;
